import { useEffect, useState } from "react";
import OptimizedImage from "@/components/OptimizedImage";

interface HeroSlideshowProps {
  images: string[];
  interval?: number;
}

const HeroSlideshow = ({ images, interval = 5000 }: HeroSlideshowProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    console.log('HeroSlideshow: Images received:', images);
    if (images.length === 0) {
      console.warn('HeroSlideshow: No images provided');
      return;
    }

    const timer = setInterval(() => {
      if (images.length <= 1) return;
      
      setTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
        setNextIndex((prev) => (prev + 1) % images.length);
        setTransitioning(false);
      }, 1000);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  if (images.length === 0) {
    return (
      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
        <p className="text-white">Loading hero images...</p>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 w-full h-full">
      {images.map((image, index) => (
        <div
          key={image}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentIndex
              ? transitioning
                ? "opacity-0"
                : "opacity-100"
              : index === nextIndex && transitioning
              ? "opacity-100"
              : "opacity-0"
          }`}
        >
          <div className="relative w-full h-full">
            <OptimizedImage
              src={image}
              alt={`Evolutions Medspa Environment ${index + 1}`}
              className="w-full h-full object-cover object-center md:object-[50%_35%]"
              width={1920}
              height={1080}
              priority={index === 0}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/40"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HeroSlideshow;